import React from 'react';
import image1 from '../../../../../images/modules/module-1/1.png';
import image2 from '../../../../../images/modules/module-1/2.png';
import image3 from '../../../../../images/modules/module-1/3.png';
import image4 from '../../../../../images/modules/module-1/4.png';
import image5 from '../../../../../images/modules/module-1/5.png';
import image6 from '../../../../../images/modules/module-1/6.png';
import image7 from '../../../../../images/modules/module-1/7.png';
import { generateRandomDate } from '../../../utils';
import { Ad } from '../Ad';
import './index.scss';

export const InAdContent = ({ src }) => {
    return (
        <div className='revue-main-content'>
            <div className='revue-grid'>
                <div className='revue-grid__left-top'>
                    <Ad
                        src={image1}
                        category='Celebrity Style'
                        title='32 Celebrity Vintage Fashion Moments That Live In My Mind Rent-Free'
                        date={generateRandomDate()}
                    />
                </div>
                <div className='revue-grid__left-bottom'>
                    <Ad
                        src={image2}
                        category='Fashion'
                        title='’60s Super Penelope Tree Recalls Witnessing The Birth Of Boho Style'
                        date={generateRandomDate()}
                    />
                </div>
                <div className='revue-grid__center'>
                    <Ad
                        src={image3}
                        category='Magazine'
                        title='Karen Elson and Scarlett White on Vintage Fashion, Creativity, and Shooting at Home With Annie Leibovitz'
                        date={generateRandomDate()}
                        size='big'
                        contentHeightSmall
                    />
                </div>
                <div className='revue-grid__right-top'>
                    <div className='ad'>
                        <div className='ad__category'>Events</div>
                        <div className='ad__title'>Business Global Summit, Shaping the future of luxury</div>
                        <div className='ad__button'>
                            <button>Subscribe</button>
                        </div>
                    </div>
                    <div className='ad-text'>Advertisement</div>
                </div>
                <div className='revue-grid__in-ad'>
                    <iframe title='in-ad' src={src} width={300} height={600} />
                </div>
                <div className='revue-grid__bottom-1'>
                    <Ad
                        src={image4}
                        category='Shopping'
                        title='The Best Foundation Brushes Blend Makeup With Ease for a Flawless Base'
                        type='inverted'
                    />
                </div>
                <div className='revue-grid__bottom-2'>
                    <Ad
                        src={image5}
                        category='Travel'
                        title='The Trip That Helped Me Come to Peace With Surrogacy'
                        type='inverted'
                    />
                </div>
                <div className='revue-grid__bottom-3'>
                    <Ad
                        src={image6}
                        category='Wellness'
                        title='9 Delicious High-Protein Foods To Eat Daily'
                        type='inverted'
                    />
                </div>
                <div className='revue-grid__bottom-4'>
                    <Ad
                        src={image7}
                        category='Runway'
                        title='Evening Glamour and Animal Prints Are It Outside the Shanghai Fall 2025 Shows'
                        type='inverted'
                    />
                </div>
            </div>
        </div>
    );
};
